import { ProductGender } from '../products-matrix/product-gender.enum';
import { ProductMainGroups } from '../products-matrix/product-main-groups.enum';
import type { LocalizedSizes } from './localized-sizes.interface';

/**
 * Represents a single order line in a Backstage order.
 * Note: `productId` refers to the variant EAN/barcode, not the product group number.
 */
export class OrderLineModel {
  /** Variant identifier (EAN/barcode), not the product group number */
  public productId: string;
  public name: string;
  public description: string;
  public unitPrice: number;
  public quantity: number;
  public totalPrice: number;
  public dueDate?: string | Date;
  public orderLineNumber: string;
  public lineItemNumber: number;
  public unitDiscount: number;
  public productColorId: string;
  public productSizeId: string;
  public locationId: string;
  public unitOfMeasure: string;
  public receiptRequestedDate: string | Date;
  public receiptConfirmedDate: string | Date;
  public lineStatus: string;
  public addressName: string;
  public address: string;
  public inventoryTransactionNumber?: string;
  public productGroupName?: string;
  public quantityCancelled: number;
  public quantityShipped: number;
  public quantityUpdated?: number;
  public launchDate?: string | Date;
  public customerName?: string;

  /**
   * Product category (main group), resolved server-side from the product catalog by barcode.
   * Undefined when the product could not be resolved.
   */
  public mainGroup?: ProductMainGroups;

  /**
   * Product gender, resolved server-side from the product catalog by barcode.
   * Undefined when the product could not be resolved.
   */
  public gender?: ProductGender;

  /**
   * Product imagery URL, resolved server-side from the product catalog by barcode.
   * Undefined when the product could not be resolved.
   */
  public imageUrl?: string;

  /**
   * Product color name, resolved server-side from the product catalog by barcode.
   * Undefined when the product could not be resolved.
   */
  public colorName?: string;

  /**
   * Localized size dimensions, resolved server-side from the product catalog by barcode.
   * Undefined when the product could not be resolved.
   */
  public localizedSizes?: LocalizedSizes;

  // @deprecated
  public externalId?: string;
  // @deprecated
  public id?: string;
}
